import "./style.css";
import gsap from "gsap";

export default class Header {
  static selector = ".s-header";

  constructor(block) {
    this.isGhostNav = !document.body.classList.contains("nav-full");
    this.block = block;
    this.$animationHeader = document.body.querySelector(".s-header__content");
    this.$user = block.querySelector("#user");
    this.$ham = block.querySelector("#ham");
    this.$nav = block.querySelector("nav");
    this.lastScroll = 0;
    this.animation =
      !document.documentElement.classList.contains("header-animated") &&
      document.body.classList.contains("animate-header");

    if (this.animation) this.animate();
    window.__$ham = this.$ham;
    window.__$user = this.$user;
    this.addListeners();
  }

  // Public methods

  animate() {
    this.block.classList.add("animation-started");
    gsap.to(this.$animationHeader, {
      duration: 2,
      delay: 1,
      ease: "power4.inOut",
      y: 0,
      onComplete: () => {
        document.documentElement.classList.add("header-animated");
      },
    });
  }

  onMouseWheel(e) {
    if (this.menuOpen) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }

  onUserClick() {
    const $sideNavLogin = document.querySelector(".s-side-nav-login");
    const $menu = $sideNavLogin.querySelector(".s-side-nav__menu");
    let menuOpen = parseInt($sideNavLogin.getAttribute("data-active"), 10);
    menuOpen = menuOpen === 0 ? 1 : 0;
    $sideNavLogin.setAttribute("data-active", menuOpen);
    gsap.to($menu, {
      x: menuOpen ? 0 : "100%",
      ease: "power3.inOut",
      duration: 0.75,
    });
  }

  onClick() {
    const $sideNav = document.querySelector(".s-side-nav");
    const $menu = $sideNav.querySelector(".s-side-nav__menu");
    let menuOpen = parseInt($sideNav.getAttribute("data-active"), 10);
    menuOpen = menuOpen === 0 ? 1 : 0;
    $sideNav.setAttribute("data-active", menuOpen);
    gsap.to($menu, {
      x: menuOpen ? 0 : "100%",
      ease: "power3.inOut",
      duration: 0.75,
    });
  }

  checkBodyClass() {
    this.block.classList.remove("ghost");
    document.body.classList.remove("nav-full");
    document.body.classList.remove("nav-full__scrolled");

    let split;
    const $main = this.block.querySelector("img#logo");
    const uri = this.block.getAttribute("data-uri");
    const { pathname } = window.location;

    if (
      pathname === "/" ||
      pathname.includes("membership") ||
      pathname.includes("training") ||
      pathname.includes("publications") ||
      pathname.includes("event") ||
      pathname.includes("dashboard") ||
      pathname.includes("profile") ||
      pathname.includes("404") ||
      document.body.classList.contains("page-404")
    ) {
      split = pathname.split("/");
      if (split.length <= 3) this.block.classList.add("ghost");
    } else if (
      pathname.includes("privacy-policy") ||
      pathname.includes("terms-conditions") ||
      pathname.includes("password-reset")
    ) {
      document.body.classList.add("nav-full");
      document.body.classList.add("nav-full__scrolled");
    }

    if (this.block.classList.contains("ghost")) {
      $main.setAttribute("src", `${uri}/assets/images/logo-sela-white.png`);
    } else {
      $main.setAttribute("src", `${uri}/assets/images/logo-sela.png`);
    }
  }

  addListeners() {
    window.__refresh = () => {
      this.checkBodyClass();
      this.onScroll({ y: window.scrollY });
    };

    if (this.$user) this.$user.addEventListener("click", this.onUserClick);
    this.$ham.addEventListener("click", this.onClick);
    document.body.addEventListener("wheel", this.onMouseWheel);
    this.checkBodyClass();

    if (
      window.location.href.includes("user=not-logged-in") ||
      window.location.href.includes("errors=") ||
      window.location.href.includes("mail=")
    ) {
      this.onUserClick();
      if (window.location.href.includes("mail=")) {
        setTimeout(() => {
          window.__onForgetPasswordClick && window.__onForgetPasswordClick();
        }, 0);
      }
    }
  }

  onScroll({ y }) {
    const navFull = "nav-full";
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    const scrollDownBar = "scroll-down-bar";
    const { body } = document;

    if (y <= 0) {
      body.classList.remove(scrollUp);
      if (this.isGhostNav) body.classList.remove(navFull);
      return;
    }

    if (y > this.lastScroll && !body.classList.contains(scrollDown)) {
      // down
      body.classList.remove(scrollUp);
      body.classList.add(scrollDown);
    } else if (y < this.lastScroll && body.classList.contains(scrollDown)) {
      // up
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);
      body.classList.add(navFull);
    }

    this.lastScroll = y;
  }
}
